import { render } from "./ChangePasswordDialog.vue?vue&type=template&id=a0351742&scoped=true"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js"

import "./ChangePasswordDialog.vue?vue&type=style&index=0&id=a0351742&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0351742"]])

export default __exports__